module.exports = __webpack_public_path__ + "static/media/Barana.dcbc82db.png";